import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Abholung',
  [OrderMethod.Delivery]: 'Lieferung',
  [OrderMethod.OnSite]: 'Tischbestellung',
};
